import { Component, OnInit } from '@angular/core';

import { MessageDisplayUtil } from 'src/message-display-utils';
import {
  AlertController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { PaymentService } from 'src/providers/payment-service/payment-service';
import {
  TeeTimeSlotDisplay,
  DisplayPrices,
  CurrencyData,
  BuggyAssignment,
  BuggyData,
  TeeTimeBooking,
  CaddyData,
  CaddyAssignment,
  TeeTimeBookingPlayer,
  ItemizedBill,
  BookingPlayerCharges,
  BillItem,
  PaymentGatewayInfo,
  BookingOfflinePayment,
  OfflinePayment,
  TeeTimeClubVoucher,
  TeeTimeBookingDiscount,
  PlayerClubAccount,
  TeeTimeBookingOptions,
  PlayerInfo,
  ClubMembership,
} from 'src/data/mygolf.data';
import { GameRoundInfo } from 'src/data/game-round';
import { CompetitionInfo } from 'src/data/competition-data';
import { DeleteRoomModalComponent } from '../../package-details/package-booking/delete-room-modal/delete-room-modal.component';

export interface ClubPaymentMethod {
  id: string;
  name: string;
  visible: boolean;
  enabled: boolean;
  checked: boolean;
  APIname: string;
}

@Component({
  selector: 'app-prices-display',
  templateUrl: './prices-display.page.html',
  styleUrls: ['./prices-display.page.scss'],
})
export class PricesDisplayPage implements OnInit {
  public competition: CompetitionInfo;
  public gameRound: GameRoundInfo;
  public headerName: string;
  teeSlot: TeeTimeBooking;
  prices: DisplayPrices;
  currency: CurrencyData;

  buggyAssigned: Array<BuggyData> = new Array<BuggyData>();
  caddyAssigned: Array<CaddyData> = new Array<CaddyData>();
  caddyPreferred: Array<CaddyData> = new Array<CaddyData>();
  selectPaymentMethod: string = 'online'; // online, credit-card, charge-account

  paymentAmountType: string = 'full'; //full,deposit

  depositAmount: number = 0;
  type: string = 'payment_confirm';
  itemBill: ItemizedBill;
  countryId: string;
  paymentGatewayList: Array<PaymentGatewayInfo>;
  clubPayment: boolean;
  clubPaymentMethod: Array<string> = ['cash']; //['none'];
  fullAmountType: Array<string> = ['specific'];
  clubPaymentArray: Array<number> = [0];
  clubAmount: Array<number> = [0];
  totalClubAmount: number;
  clubPaymentRemarks: Array<string> = [''];
  bookingDiscounts: Array<TeeTimeBookingDiscount>;
  playerClubAccount: PlayerClubAccount;
  playerMaxChargeableAmount: number;
  bookingOptions: TeeTimeBookingOptions;
  playerAssignment: Array<any> = new Array<any>();

  caddyAssignmentInfo: any;
  fromClub: boolean = false;
  currentPlayer: PlayerInfo;
  currencyCode: string;
  extraBuggyAssigned: Array<any> = new Array<any>(); // Array<BuggyData> = new Array<BuggyData>();
  extraCaddyAssigned: Array<any> = new Array<any>(); //Array<CaddyData> = new Array<CaddyData>();
  constructor(
    public nav: NavController,
    private navParams: NavParams,

    private alertCtrl: AlertController,
    private modalCtl: ModalController,
    private platform: Platform,
    private toastCtl: ToastController,
    private paymentService: PaymentService,
    private flightService: ClubFlightService
  ) {
    this.competition = this.navParams.get('competition');
    this.gameRound = this.navParams.get('gameRound');
    this.headerName = this.navParams.get('headerName');
    this.teeSlot = this.navParams.get('slot');
    if (this.teeSlot)
      this.countryId = this.teeSlot.clubData.address.countryData.id;

    this.type = this.navParams.get('type');
    this.itemBill = this.navParams.get('itemBill');
    this.caddyAssignmentInfo = this.navParams.get('caddyAssignmentInfo');
    this.bookingOptions = this.navParams.get('bookingOptions');
    this.fromClub = this.navParams.get('fromClub');
    this.currentPlayer = this.navParams.get('currentPlayer');
    this.countryId = this.navParams.get('countryId');
    this.currencyCode = this.navParams.get('currencyCode');
    if (this.itemBill)
      this.itemBill.playerCharges.sort((a, b) => {
        if (a.sequence < b.sequence) return -1;
        else if (a.sequence > b.sequence) return 1;
        else return 0;
      });
    this.depositAmount = this.navParams.get('depositAmount');
    this.paymentGatewayList = this.navParams.get('paymentGatewayList');
    if (this.paymentGatewayList && this.paymentGatewayList.length > 0)
      this.selectPaymentMethod = this.paymentGatewayList[0].id;
    else if (
      (this.type === 'payment_confirm' &&
        this.paymentGatewayList &&
        this.paymentGatewayList.length === 0) ||
      (this.type === 'payment_confirm' && !this.paymentGatewayList)
    ) {
      let _countryId = this.teeSlot.clubData.address.countryData.id;
      this.paymentService
        .getPaymentGateway(_countryId)
        .subscribe((pgList: Array<PaymentGatewayInfo>) => {

          if (pgList && pgList.length > 0) {
            this.paymentGatewayList = pgList;
            this.selectPaymentMethod = this.paymentGatewayList[0].id;
          }
        });
    } else if (
      (this.type === 'payment_application' &&
        this.paymentGatewayList &&
        this.paymentGatewayList.length === 0) ||
      (this.type === 'payment_application' && !this.paymentGatewayList)
    ) {
      this.paymentService
        .getPaymentGateway(this.countryId)
        .subscribe((pgList: Array<PaymentGatewayInfo>) => {

          if (pgList && pgList.length > 0) {
            this.paymentGatewayList = pgList;
            this.selectPaymentMethod = this.paymentGatewayList[0].id;
          }
        });
    }


    // this.prices = this.teeSlot.displayPrices;
    // this.currency = this.teeSlot.currency;
    if (this.teeSlot) {
      this.buggyAssigned.push(...this.teeSlot.buggiesAssigned);
      // this.depositAmount = this.navParams.get("depositAmount")>0?this.depositAmount:this.teeSlot.depositPayable;
    }
    // let _extraBuggyAssigned = JSON.parse(JSON.stringify(this.teeSlot.buggiesAssigned));
    // let _extraCaddyAssigned = JSON.parse(JSON.stringify(this.teeSlot.caddiesAssigned));
    if (this.type === 'payment_application') {
    } else {
      this.extraBuggyAssigned.push(...this.teeSlot.buggiesAssigned); // Object.assign({}, this.teeSlot.buggiesAssigned); //JSON.parse(JSON.stringify(this.teeSlot.buggiesAssigned));
      this.extraCaddyAssigned.push(...this.teeSlot.caddiesAssigned); // Object.assign({}, this.teeSlot.caddiesAssigned); //JSON.parse(JSON.stringify(this.teeSlot.caddiesAssigned));

      this.extraBuggyAssigned = this.extraBuggyAssigned.filter((buggy) => {
        let _assigned = null;
        _assigned = this.teeSlot.bookingPlayers.find((bookingPlayer) => {
          // if(buggyAsgn.id === buggy.id) _assigned = true
          return bookingPlayer.buggyId === buggy.id;
        });

        if (_assigned) return false;
        else return true;
      });
      if (this.teeSlot)
        this.teeSlot.bookingPlayers.forEach((tb: TeeTimeBookingPlayer) => {
          this.caddyAssigned.push(tb.caddyAssigned);
          this.caddyPreferred.push(tb.caddyPreferred);
        });
      if (this.extraCaddyAssigned)
        this.extraCaddyAssigned = this.extraCaddyAssigned.filter((caddy) => {
          // let _assigned: boolean = false;
          let _assigned = this.caddyAssigned.find((caddyAsgn) => {
            // if(buggyAsgn.id === buggy.id) _assigned = true
            if (caddyAsgn && caddy) return caddyAsgn.id === caddy.id;
          });
          if (_assigned) return false;
          else return true;
        });
      if (this.extraBuggyAssigned)
        this.extraBuggyAssigned.forEach((buggy) => {
          buggy.used = false;
        });
      if (this.extraCaddyAssigned)
        this.extraCaddyAssigned.forEach((caddy) => {
          caddy.used = false;
        });


      this.getExtraAssigned();
    }
    this.paymentAmountType = this.navParams.get('paymentAmountType');
    this.clubPayment =
      this.navParams.get('clubPayment') === true ? true : false;

    this.bookingDiscounts = this.navParams.get('voucherApplied');



    if (
      this.type === 'payment_confirm' &&
      !this.clubPayment &&
      this.bookingOptions &&
      this.bookingOptions.chargeToAccountEnabled
    ) {
      this.getClubMembership()
        .then((data: any) => {

          if (data.status === 'success') {
            if (
              data.clubMembership &&
              data.clubMembership.status.toLowerCase().includes('active')
            )
              this.getPlayerClubAccount();
          }
        })
        .catch((data) => { });
    }
  }

  close() {
    this.modalCtl.dismiss();
  }
  getExtraAssigned(type?: string, player?: any) {
    // if(!type) return;
    // // if(!player) return;
    // if(!this.teeSlot) return;
    if (
      this.teeSlot &&
      (!this.teeSlot.additionalItems ||
        this.teeSlot.additionalItems.length === 0)
    )
      return;
    let _playerAssigned: Array<any> = JSON.parse(
      JSON.stringify(this.teeSlot.bookingPlayers)
    );

    let _additionalItems = JSON.parse(
      JSON.stringify(this.teeSlot.additionalItems)
    );
    let _extBuggy;
    let _extCaddy;
    let _itemCountB;
    let _itemCountC;
    let _buggyName;
    let _caddyName;
    _playerAssigned.forEach((player) => {
      _extBuggy = _additionalItems.filter((item) => {
        return (
          item.component.componentType.toLowerCase() === 'buggy' &&
          item.bookingPlayer &&
          item.bookingPlayer.id === player.id
        );
      });
      _extCaddy = _additionalItems.filter((item) => {
        return (
          item.component.componentType.toLowerCase() === 'caddy' &&
          item.bookingPlayer &&
          item.bookingPlayer.id === player.id
        );
      });

      if (_extBuggy.length > 0) {
        _itemCountB = _extBuggy[0].itemCount;
        let _removedBuggy;
        let _filteredBuggy = this.extraBuggyAssigned.filter((buggy) => {
          return !buggy.used;
        });
        if (_filteredBuggy.length === 0) return;
        _removedBuggy = _filteredBuggy.slice(0, _itemCountB);
        // this.extraCaddyAssigned.splice(0,_itemCount);

        // this.extraCaddyAssigned =
        this.extraBuggyAssigned.forEach((buggy) => {
          let _removed = _removedBuggy.find((b) => {
            return b.id === buggy.id;
          });
          if (_removed && !buggy.used) buggy.used = true;
          // if(_removed) return false
          // else return true
        });
        _buggyName = _removedBuggy
          .map((buggy) => {
            return buggy.buggyNo;
          })
          .join(', ');
        player.extraBuggies = _buggyName;
        player.extraTotalBuggies = _removedBuggy.length;
      }

      if (_extCaddy.length > 0) {
        _itemCountC = _extCaddy[0].itemCount;
        let _removedCaddy;
        let _filteredCaddy = this.extraCaddyAssigned.filter((caddy) => {
          return !caddy.used;
        });
        if (_filteredCaddy.length === 0) return;
        _removedCaddy = _filteredCaddy.slice(0, _itemCountC);
        // this.extraCaddyAssigned.splice(0,_itemCount);

        // this.extraCaddyAssigned =
        this.extraCaddyAssigned.forEach((caddy) => {
          let _removed = _removedCaddy.find((c) => {
            return c.id === caddy.id;
          });
          if (_removed && !caddy.used) caddy.used = true;
          // if(_removed) return false
          // else return true
        });
        _caddyName = _removedCaddy
          .map((caddy) => {
            return caddy.firstName + ' ' + caddy.lastName;
          })
          .join(', ');
        player.extraCaddies = _caddyName;
        player.extraTotalCaddies = _removedCaddy.length;
      }
    });
    this.playerAssignment = _playerAssigned;

  }
  addClubPayment(item: number) {
    let _totalAmount = this.clubAmount.reduce((a, b) => {
      return Number(a) + Number(b);
    });
    if (this.clubAmount[item] < 1) {
      MessageDisplayUtil.showMessageToast(
        'Please enter an amount',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    } else if (
      this.clubAmount[item] > Number(this.getBookingDetails('price'))
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please enter amount not more than ' +
        Number(this.getBookingDetails('price')),
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    } else if (_totalAmount >= Number(this.getBookingDetails('price'))) {
      MessageDisplayUtil.showMessageToast(
        'Total amount has reached ' + Number(this.getBookingDetails('price')),
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    this.previewTotalClubAmount();
    this.clubPaymentArray.push(item + 1);
    if (this.clubPaymentArray[item + 1]) {
      this.fullAmountType[item + 1] = 'specific';
      this.clubPaymentMethod[item + 1] = 'cash';
      this.clubPaymentRemarks[item + 1] = '';
      this.clubAmount[item + 1] = 0;
    }
    if (item === 0 && this.clubPaymentMethod[item] !== 'clbc') {
      this.clubPaymentMethodList = this.clubPaymentMethodList.filter((cpm) => {
        if (cpm && cpm.APIname === 'clbc') {
          this.clubPaymentChargeAccount = cpm;
        }
        return cpm && cpm.APIname !== 'clbc';
      });

    }
  }
  clubPaymentChargeAccount: any;

  removeClubPayment(item: number) {
    this.clubPaymentArray.splice(item, 1);
    this.fullAmountType.splice(item, 1);
    this.clubPaymentMethod.splice(item, 1);
    this.previewTotalClubAmount();
    if (item > 0) {
      let _checkCta = this.clubPaymentMethodList.filter((cpm) => {
        return cpm && cpm.APIname === 'clbc';
      });
      if (_checkCta && _checkCta.length === 0) {
        this.clubPaymentMethodList.push(this.clubPaymentChargeAccount);
      }
    }
  }

  addClubAmount(amount: number, item: number) {
    if (amount < 0) {
      this.clubAmount[item] = 0;
      this.previewTotalClubAmount();
      return false;
    } else if (amount > Number(this.getBookingDetails('price'))) {
      this.clubAmount[item] = Number(this.getBookingDetails('price'));
      this.previewTotalClubAmount();
      return false;
    }
    if (1) return false;
    else if (
      this.totalClubAmount + amount >
      Number(this.getBookingDetails('price'))
    ) {
      return false;
    }
    // // this.previewTotalClubAmount(item);
    // this.clubAmount[item] = Number(this.getBookingDetails('price')) - this.totalClubAmount;
    // } else if (amount > Number(this.getBookingDetails('price'))) {
    //     // this.previewTotalClubAmount(item);
    //     this.clubAmount[item] = Number(this.getBookingDetails('price'));
    //     }
    this.previewTotalClubAmount();
    if (1) return false;
    // if(this.clubAmount[item] > 0) return false;
    this.totalClubAmount = 0;
    this.totalClubAmount = this.clubAmount.reduce((a, b) => {
      return Number(a) + Number(b);
    });
    this.clubAmount[item] = 0;
    let _totalClubAmount = this.totalClubAmount;
    let _amount = amount;

    if (_amount + _totalClubAmount > Number(this.getBookingDetails('price')))
      _amount =
        Number(this.getBookingDetails('price')) - Number(_totalClubAmount);
    // else if(this.totalClubAmount > Number(this.getBookingDetails('price'))) {
    //     _amount = Number(this.getBookingDetails('price'))
    // }
    else if (amount > Number(this.getBookingDetails('price'))) {
      _amount = Number(this.getBookingDetails('price')) - amount;
    }
    // else if (_amount < 0) return false
    else _amount = amount;
    // this.totalClubAmount += _amount;
    if (this.clubAmount[item] === 0) this.clubAmount[item] = _amount;
  }

  previewTotalClubAmount(item?: number) {
    let _toPayAmount = Number(this.getBookingDetails('price'));
    this.totalClubAmount = 0;
    let _currentTotal = 0;
    this.totalClubAmount = this.clubAmount.reduce((a, b, index) => {
      // if(item && index === item) return Number(a) + 0
      // else return Number(a) + Number(b)
      // _currentTotal = Number(a) + Number(b);
      // _currentTotal += Number(a)
      // if(_toPayAmount <= _currentTotal) return _currentTotal;

      // else
      if (_toPayAmount < Number(a) + Number(b)) {
        // this.clubAmount[index] = 0;
        this.clubAmount[index] = Number((_toPayAmount - a).toFixed(2));

        // MessageDisplayUtil.showMessageToast(this.selectPaymentMethod + ' - Please select 1 (one) payment method to proceed.',
        //                     this.platform, this.toastCtl, 3000, "bottom")
        return Number(a.toFixed(2));
      } else return Number(a.toFixed(2)) + Number(b.toFixed(2));
      // return Number(a) + Number(b)
    });

    if (this.totalClubAmount > Number(this.getBookingDetails('price'))) {
      this.totalClubAmount = Number(
        Number(this.getBookingDetails('price')).toFixed(2)
      );
    }
    // this.totalClubAmount = Number(this.totalClubAmount.toFixed(2))
  }

  cancelPayment() {
    this.modalCtl.dismiss({
      confirm: false,
      paymentAmountType: this.paymentAmountType,
      depositAmount: this.depositAmount,
    });
  }

  ngOnInit() {
    this.getAppAttribute();
  }

  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }

  getBuggyAssigned(player: TeeTimeBookingPlayer) {
    let _player = player;
    let _buggyText = this.buggyAssigned
      .filter((buggy: BuggyData) => {
        return buggy.id === player.buggyId;
      })
      .map((buggy: BuggyData) => {
        return buggy.id + ' (' + buggy.name + ')';
      });
    return _buggyText[0];
  }

  getCaddyAssigned(player: TeeTimeBookingPlayer) {
    let _player = player;
    let _caddyText = this.caddyAssigned
      .filter((caddy: CaddyData) => {
        return caddy.id === player.caddyAssigned.id;
      })
      .map((caddy: CaddyData) => {
        return caddy.firstName + ' (' + caddy.staffId + ')';
      });
    return _caddyText[0];
  }

  getCaddyPreferred(player: TeeTimeBookingPlayer) {
    let _player = player;
    let _caddyText = this.caddyPreferred
      .filter((caddy: CaddyData) => {
        return caddy.id === player.caddyPreferred.id;
      })
      .map((caddy: CaddyData) => {
        return caddy.firstName + ' (' + caddy.staffId + ')';
      });

    return _caddyText[0];
  }

  async onPayNow() {
    if (this.type === 'payment_application') {
      if (
        this.selectPaymentMethod === '' ||
        this.selectPaymentMethod === null
      ) {
        MessageDisplayUtil.showMessageToast(
          ' - Please select a payment method to proceed.',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      }
      let _message = '';
      if (this.isIOS())
        _message =
          'You are using iOS device, you may need to disable any content blocker first. This will bring up the payment system. Do you want to proceed?';
      else
        _message =
          'This will bring up the payment system. Do you want to proceed?';

      this.modalCtl.dismiss({
        confirm: true,
        paymentAmountType: this.paymentAmountType,
        depositAmount: this.depositAmount,
        selectPaymentMethod: this.selectPaymentMethod,
      });
      return;
    }
    if (this.clubPayment) {
      this.previewTotalClubAmount();
      if (this.totalClubAmount === 0) {
        MessageDisplayUtil.showMessageToast(
          'Please enter an amount',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      }


      let _zeroAmountIdx;
      // this.clubAmount.filter((amount: number, idx: number) =>{
      //     if(amount === 0) _zeroAmountIdx = idx;
      // })
      // this.clubAmount.splice(_zeroAmountIdx, 1);


    }
    // if(this.depositAmount <= 0) {
    if (this.getBookingDetails('price') <= '0') {
      MessageDisplayUtil.showMessageToast(
        'Total amount is less than 0',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    // MessageDisplayUtil.showMessageToast(this.selectPaymentMethod + ' - Please select 1 (one) payment method to proceed.',
    //                     this.platform, this.toastCtl, 3000, "bottom")
    // if(1) return false;

    if (this.selectPaymentMethod === '' || this.selectPaymentMethod === null) {
      MessageDisplayUtil.showMessageToast(
        ' - Please select a payment method to proceed.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _title = 'Redirecting to payment page';
    let _message = '';
    if (this.selectPaymentMethod === 'chgacc')
      _message = 'This will charge to account. Do you want to proceed?';
    else if (this.isIOS())
      _message =
        'You are using iOS device, you may need to disable any content blocker first. This will bring up the payment system. Do you want to proceed?';
    else
      _message =
        'This will bring up the payment system. Do you want to proceed?';

    // if(!this.clubPayment) {
    //     if(this.selectPaymentMethod.includes('billplz') && this.teeSlot && this.teeSlot.bookingPlayers[0].phone.length < )
    // }
    if (this.clubPayment) {
      _title = 'Confirm Payment';
      _message =
        'Total Amount is ' +
        this.teeSlot.slotAssigned.currency.symbol +
        ' ' +
        this.numberWithCommas(this.totalClubAmount) +
        '. Do you want to proceed?';
      // Number(this.totalClubAmount.toFixed(2))
    }
    // else if(this.selectPaymentMethod === 'chgacc') {

    // }
    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop:true,
      mode:'ios',
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
        mode:'priceDetails',
        msg:_message,
        header:_title
      }      
    });
    await modal.present();
    modal.onDidDismiss().then((data)=>{
      if(data){
        if(data?.data === 'confirm'){         
          if (this.clubPayment) {
            let _offlinePayments: Array<OfflinePayment> = [{}];
            this.clubPaymentArray.forEach((i) => {
              if (this.clubAmount[i] > 0) {
                let _singlePayment: OfflinePayment = {};
                _singlePayment.paymentMethod = this.clubPaymentMethod[i];
                _singlePayment.amount = this.clubAmount[i];
                _singlePayment.remarks = this.clubPaymentRemarks[i];
                _singlePayment.paidByName =
                  this.teeSlot.bookingPlayers[0].playerName;
                _singlePayment.paidByEmail =
                  this.teeSlot.bookingPlayers[0].email;
                _singlePayment.paidByPhone =
                  this.teeSlot.bookingPlayers[0].phone;
                // _singlePayment.paidByName = 'nikzaki';
                // _singlePayment.paidByEmail = 'nikzaki@britesoftcorp.com';
                // _singlePayment.paidByPhone = '0123456789';
                _singlePayment.currency =
                  this.teeSlot.slotAssigned.currency.id;
                _offlinePayments.push(_singlePayment);
              }
            });
            _offlinePayments.shift();
            //  = [{
            //     paymentMethod: '',
            //     currency: '',
            //     amount: 0
            // }];
            // this.clubPaymentMethod.forEach((paymentMethod: string)=>{
            //     _singlePayment.push(paymentMethod)
            // })
            // this.clubAmount.forEach((amount: number)=>{
            //     _offlinePayments['amount'].push(amount)
            // })
            // this.clubPaymentRemarks.forEach((remarks: string)=>{
            //     _offlinePayments['remarks'].push(remarks)
            // })


            this.modalCtl.dismiss({
              confirm: true,
              paymentAmountType: this.paymentAmountType,
              depositAmount: this.depositAmount,
              selectPaymentMethod: this.selectPaymentMethod,
              clubPayment: true,
              offlinePayments: _offlinePayments,
            });
          } else if (this.selectPaymentMethod === 'chgacc') {
            let _amountToPay;
            if (this.playerClubAccount) {
              if (
                this.playerClubAccount.allowCredit &&
                this.playerClubAccount.creditLimitApplicable
              ) {
                if (this.paymentAmountType === 'deposit') {
                  if (this.depositAmount > this.playerMaxChargeableAmount)
                    _amountToPay = this.playerMaxChargeableAmount;
                  else _amountToPay = this.depositAmount;
                } else if (this.paymentAmountType === 'full') {
                  if (
                    this.getBookingBalance(true) >
                    this.playerMaxChargeableAmount
                  )
                    _amountToPay = this.playerMaxChargeableAmount;
                  else _amountToPay = this.getBookingBalance(true);
                } else if (this.paymentAmountType === 'mine') {
                  if (this.depositAmount > this.playerMaxChargeableAmount)
                    _amountToPay = this.playerMaxChargeableAmount;
                  else _amountToPay = this.depositAmount;
                }
              } else if (
                this.playerClubAccount.allowCredit &&
                !this.playerClubAccount.creditLimitApplicable
              ) {
                _amountToPay = this.getBookingBalance(true);
              } else _amountToPay = this.getBookingBalance(true);
            }
            this.modalCtl.dismiss({
              confirm: true,
              paymentAmountType: this.paymentAmountType,
              depositAmount: _amountToPay,
              selectPaymentMethod: this.selectPaymentMethod,
            });
          } else {
            this.modalCtl.dismiss({
              confirm: true,
              paymentAmountType: this.paymentAmountType,
              depositAmount: this.depositAmount,
              selectPaymentMethod: this.selectPaymentMethod,
            });
          }
        }
      }
    })
  }

  getBookingDetails(attribute?: any) {
    let _statusText = '';
    if (attribute === 'status') {
      let _bookingStatus = this.teeSlot.bookingStatus;
      if (_bookingStatus === 'Booked') _statusText = 'Booked';
      else if (_bookingStatus === 'PaymentFull') _statusText = 'Paid in Full';
      else if (_bookingStatus === 'PaymentPartial')
        _statusText = 'Deposit Paid';
      else _statusText = _bookingStatus ? _bookingStatus : '';
    }
    // let _amountPayable = (this.paymentAmountType === 'full')?this.teeSlot.amountPayable - this.teeSlot.amountPaid - this.teeSlot.totalDeductions:this.depositAmount;
    let _amountPayable =
      this.paymentAmountType === 'full'
        ? this.itemBill.balance
        : this.depositAmount;

    switch (attribute) {
      case 'reference':
        return 'Ref #' + this.teeSlot.bookingReference;
      case 'price':
        if (
          this.selectPaymentMethod === 'chgacc' &&
          this.playerMaxChargeableAmount < _amountPayable
        )
          return this.playerMaxChargeableAmount;
        return _amountPayable;
      case 'currency':
        return this.teeSlot.slotAssigned.currency.symbol;
      case 'status':
        return _statusText;
    }
  }

  getPlayerTotal(player: BookingPlayerCharges) {
    let _totalPlayer = 0;
    let _totalDiscounts = 0;
    _totalPlayer = player.billItems
      .map((b) => {
        return b.itemPrice;
      })
      .reduce((a: number, b: number) => a + b);

    if (player && player.discounts && player.discounts.length > 0) {
      _totalDiscounts = player.discounts
        .map((d) => {
          return d.amount;
        })
        .reduce((a: number, b: number) => a + b);
    }

    return _totalPlayer - _totalDiscounts;
    // return this.itemBill.balance;
  }

  async onBillFullDetails() {
    let itemizedBill = await this.modalCtl.create({
      component: PricesDisplayPage,
      componentProps: {
        headerName: 'Bill Details',
        slot: this.teeSlot,
        type: 'payment_details',
        itemBill: this.itemBill,
      },
    });

    itemizedBill.onDidDismiss().then((data: any) => {
      // if(data && data.confirm) {
      // }
    });
    itemizedBill.present();
  }

  getPlayerAssigned(player: TeeTimeBookingPlayer, attribute: string) {
    let _player = player;
    let _playerTypeApplied;
    let _buggyNo;
    let _caddyBooked: CaddyData;
    let _caddyAssigned: CaddyData;
    let _caddyName = '';
    let _buggyType;
    let _buggyTypeTxt;
    switch (attribute) {
      case 'playerTypeApplied':
        _playerTypeApplied = this.itemBill.playerCharges
          .filter((p: BookingPlayerCharges) => {
            return p.bookingPlayerId === _player.id;
          })
          .map((p) => p.playerTypeApplied);
        return _playerTypeApplied;
      case 'buggy':
        _buggyNo = this.teeSlot.buggiesAssigned
          .filter((b: BuggyData) => {
            return b.id === _player.buggyId;
          })
          .map((b) => b.buggyNo);

        if (!_buggyNo) _buggyNo = '-';
        return _buggyNo;
      case 'buggyType':
        // if(_player.assignment)
        _buggyType = this.teeSlot.buggiesAssigned
          .filter((b: BuggyData) => {
            return b.id === _player.buggyId;
          })
          .map((b: BuggyData) => b.buggyType)
          .pop();

        if (!_buggyType) _buggyTypeTxt = '-';
        // else if(_buggyType.typeId === 'STANDARD') _buggyTypeTxt = ''
        else _buggyTypeTxt = _buggyType.typeName;
        return _buggyTypeTxt;
      case 'caddyBooked':
        _caddyBooked = _player.caddyPreferred ? _player.caddyPreferred : null;
        if (_caddyBooked) {
          if (_caddyBooked.firstName) _caddyName += _caddyBooked.firstName;
          if (_caddyBooked.firstName && _caddyBooked.lastName)
            _caddyName += ' ' + _caddyBooked.lastName;
          else if (!_caddyBooked.firstName && _caddyBooked.lastName)
            _caddyName += _caddyBooked.lastName;
          // _caddyName = _caddyBooked.firstName + ' '+_caddyBooked.lastName;
        } else _caddyName = '-';
        return _caddyName;

      case 'caddyAssigned':
        _caddyAssigned = _player.caddyAssigned ? _player.caddyAssigned : null;
        if (_caddyAssigned) {
          if (_caddyAssigned.firstName) _caddyName += _caddyAssigned.firstName;
          if (_caddyAssigned.firstName && _caddyAssigned.lastName)
            _caddyName += ' ' + _caddyAssigned.lastName;
          else if (!_caddyAssigned.firstName && _caddyAssigned.lastName)
            _caddyName += _caddyAssigned.lastName;
        }
        // if(_caddyAssigned) _caddyName = _caddyAssigned.firstName + ' '+_caddyAssigned.lastName;
        else _caddyName = '-';
        return _caddyName;
    }
  }

  isCordova() {
    return this.platform.is('capacitor');
  }

  isIOS() {
    return (
      this.platform.is('ios') ||
      this.platform.is('iphone') ||
      this.platform.is('ipad')
    );
  }

  getMaxAmount(amount: number) {
    let _maxAmount: number = Number(this.getBookingDetails('price'));
    return _maxAmount - this.totalClubAmount;
    // - this.totalClubAmount
  }

  setFullAmount(item: number) {
    // setTimeout(()=>{
    //     if(this.totalClubAmount > 0 && (this.totalClubAmount !== Number(this.getBookingDetails('price')))) {
    //         this.clubAmount[item] = Number(this.getBookingDetails('price')) - this.totalClubAmount;
    //     } else if(this.totalClubAmount === 0) {
    //         this.clubAmount[item] = Number(this.getBookingDetails('price'));
    //     }
    // }, 500)
    this.clubAmount[item] = 0;
    this.totalClubAmount = this.clubAmount.reduce((a, b, index) => {
      // if(item && index === item) return Number(a) + 0
      // else return Number(a) + Number(b)
      return Number(a) + Number(b);
    });
    if (
      this.totalClubAmount > 0 &&
      this.totalClubAmount !== Number(this.getBookingDetails('price'))
    ) {
      this.clubAmount[item] =
        Number(this.getBookingDetails('price')) - this.totalClubAmount;
    } else if (this.totalClubAmount === 0) {
      this.clubAmount[item] = Number(this.getBookingDetails('price'));
    }
    this.previewTotalClubAmount();
  }

  setPlaceholder(type?: string) {
    switch (type) {
      case 'cash':
        return 'Enter payment details';
      case 'offcc':
        return 'Enter credit/debit card number or details';
      case 'offnb':
        return 'Enter payment details';
      default:
        return 'Enter payment details';
    }
  }

  getRemainingAmount() {
    if (this.totalClubAmount === 0 || !this.totalClubAmount)
      return Number(Number(this.getBookingDetails('price')).toFixed(2));
    else
      return (
        Number(Number(this.getBookingDetails('price')).toFixed(2)) -
        this.totalClubAmount
      );
  }

  getPayingAmount() {
    if (this.totalClubAmount && this.totalClubAmount > 0)
      return this.numberWithCommas(this.totalClubAmount);
    else return 0;
  }

  numberWithCommas(x) {
    if (!x) return x;
    else return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getVoucherApplied() {
    if (
      (this.bookingDiscounts && this.bookingDiscounts.length === 0) ||
      !this.bookingDiscounts
    )
      return false;
    let _voucherAmount = this.bookingDiscounts
      .map((discount: TeeTimeBookingDiscount) => {
        return discount.amountDeducted;
      })
      .reduce((a: number, b: number) => {
        return a + b;
      });
    return _voucherAmount;
  }

  appAttribute: any;
  showRefundBy: boolean = false;
  clubPaymentMethodList: Array<ClubPaymentMethod>;
  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        data
          .filter((d) => {
            return d.page === 'pricesDisplay';
          })
          .map((d) => {
            this.appAttribute = d;
            this.clubPaymentMethodList = d.clubPaymentMethodList;
          });

        // if (this.appAttribute) {
        //   if (this.appAttribute.clubPaymentMethodList)
        //     this.clubPaymentMethodList =
        //       this.appAttribute.clubPaymentMethodList;
        // }
      }
    });
  }
  getBookingBalance(inNumber?: boolean) {
    if (inNumber)
      return Number(
        this.itemBill.totalPayable -
        this.itemBill.totalPayment -
        this.itemBill.totalDeductions +
        this.itemBill.totalRefund
      );
    else
      return Number(
        (
          this.itemBill.totalPayable -
          this.itemBill.totalPayment -
          this.itemBill.totalDeductions +
          this.itemBill.totalRefund
        ).toFixed(2)
      );
  }
  getPlayerClubAccount() {
    let _clubId;
    let _playerId;
    let _params;
    if (this.currentPlayer && this.currentPlayer.playerId)
      _playerId = this.currentPlayer.playerId;
    if (this.teeSlot && this.teeSlot.clubData)
      _clubId = this.teeSlot.clubData.id | this.teeSlot.clubData.clubId;
    _params = {
      clubId: _clubId,
      playerId: _playerId,
    };
    this.flightService.getPlayerClubAccount(_params).subscribe(
      (data) => {

        if (data) {
          this.playerClubAccount = data;

          this.getPlayerClubBalancePromise()
            .then((data: any) => {
              if (data && data.status === 'success') {
                this.playerMaxChargeableAmount = data.amount;
              } else this.playerMaxChargeableAmount = 0;
            })
            .catch((data) => { });
        }
      },
      (error) => {
        let _error = error.json();
        let _msg = _error.errorMessage;
        MessageDisplayUtil.showMessageToast(
          _msg,
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      }
    );
  }
  getClubMembership() {
    return new Promise((resolve, reject) => {
      let _playerId = this.currentPlayer.id | this.currentPlayer.playerId;
      let _clubId = this.teeSlot.clubData.id;
      let _params = {
        playerId: _playerId,
      };
      this.flightService
        .getPlayerMemberships(_playerId)
        // this.flightService.getFilteredClubMemberships(_clubId, _params)
        .subscribe(
          async (data: Array<ClubMembership>) => {

            if (data) {
              let _cm = data.filter((cm: ClubMembership) => {
                return cm.club && cm.club.clubId === _clubId;
              });

              if (_cm && _cm.length > 0) {
                resolve({
                  status: 'success',
                  message: 'has membership',
                  clubMembership: _cm[0],
                });
              } else {
                reject({
                  status: 'failed',
                  message: 'failed to get membership',
                  clubMembership: null,
                });
              }
            } else {
              reject({
                status: 'failed',
                message: 'failed to get membership',
                clubMembership: null,
              });
            }
          },
          (error) => {
            reject({
              status: 'failed',
              message: 'failed to get membership',
              clubMembership: null,
            });
          }
        );
    });
  }
  getPlayerClubBalancePromise() {
    let _params;
    let _clubId = this.teeSlot.clubData.id | this.teeSlot.clubData.clubId;
    let _playerId = this.currentPlayer.id | this.currentPlayer.playerId;
    _params = {
      clubId: _clubId,
      playerId: _playerId,
    };
    return new Promise((resolve, reject) => {
      if (this.playerClubAccount) {
        this.flightService.getPlayerMaxChargeableAmount(_params).subscribe(
          (data) => {

            if (data && data > 0) {
              resolve({
                status: 'success',
                message: 'sufficient balance',
                amount: data,
              });
            } else if (data === 0) {
              resolve({
                status: 'success',
                message: 'insufficient balance',
                amount: data,
              });
            } else if (data < 0) {
              reject({
                status: 'failed',
                message: 'insufficient balance',
                amount: data,
              });
            } else {
              reject({
                status: 'failed',
                message: 'no data',
                amount: data,
              });
            }
          },
          (error) => {
            reject({
              status: 'failed',
              message: 'no data',
              amount: 0,
            });
          }
        );
      } else {
        reject({
          status: 'failed',
          message: 'no data',
          amount: 0,
        });
      }
    });
  }
  isValidPlayerClubBalance() {
    if (!this.playerClubAccount) return false;
    if (this.bookingOptions && !this.bookingOptions.chargeToAccountEnabled)
      return false;
    if (this.playerClubAccount) {
      if (!this.playerClubAccount.allowCredit)
        if (this.playerClubAccount.balanceAmount > 0) return false;
        else return false;
      else if (this.playerClubAccount.allowCredit) {
        if (
          this.playerClubAccount.effectiveBalance +
          this.playerClubAccount.creditLimit >
          0
        )
          return true;
        else return false;
        // if(this.playerClubAccount.creditLimitApplicable) {
        //     if(this.playerClubAccount.effectiveBalance + this.playerClubAccount.creditLimit > 0)
        //         return true;
        //     else return false;
        // } else {
        //     if(this.playerClubAccount.effectiveBalance + this.playerClubAccount.creditLimit > 0)
        //         return true
        //     else return true
        // }
      }
      // if(this.playerClubAccount.effectiveBalance < this.playerClubAccount.creditLimit)
      //     return true;
      else return false;
    }
  }
  async setChargeAccountAmount() {

    if (this.selectPaymentMethod === 'chgacc') {
      let _msg = '';
      _msg =
        'You do not have sufficient balance. This payment amount is now set to <b>' +
        this.getBookingDetails('currency') +
        this.playerMaxChargeableAmount.toFixed(2) +
        '</b>';
      // this.payment this.getBookingDetails('price')
      let alert = await this.alertCtrl.create({
        header: 'Insufficient Credit Balance',
        // subTitle: 'Selected date is '+ _date,
        message: _msg, //'Selected date is ' + '<b>' + _date + '</b>',
        // buttons: ['Close']
        buttons: [
          {
            text: 'Ok',
            handler: () => {

            },
          },
        ],
      });
      if (this.paymentAmountType === 'full') {
        if (Number(this.getBookingDetails('price')) > this.playerMaxChargeableAmount)
          alert.present();
      }
    }
  }
  async onChange(event) {

    if (event && event !== 'clbc' && this.clubPaymentMethod.length > 0) {
      this.clubPaymentMethodList = this.clubPaymentMethodList.filter((cpm) => {
        return cpm && cpm.APIname !== 'clbc';
      });
    }
    if (event && event === 'clbc' && this.clubPaymentMethod.length === 1) {
      let alert = await this.alertCtrl.create({
        header: 'Redirecting to Charge to Account page',
        // subTitle: 'Selected date is '+ _date,
        cssClass: 'booking-error',
        message: 'This will redirect to Charge to Account page', //'Selected date is ' + '<b>' + _date + '</b>',
        // buttons: ['Close']
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              this.modalCtl.dismiss({
                confirm: true,
                chargeToAccount: true,
              });
            },
          },
        ],
        backdropDismiss: false,
      });
      alert.present();
    }
    // else if(event && event === 'clbc' && this.clubPaymentMethod.length > 1) {
    // if(this.clubPaymentMethod[0] === 'clbc') {

    // }
    // else {
    //     this.clubPaymentMethod.filter((method)=>{

    //     })
    // }
  }

  
  showCaddyAssignedInfo(bookingPlayer: TeeTimeBookingPlayer) {
    // if(this.teeSlotNew) return false;
    if(!bookingPlayer) return false;
    if(this.fromClub) return true;
    
    if(this.bookingOptions && this.bookingOptions.showCaddieAssignments) return true;
    // else if(this.bookingOptions && !this.bookingOptions.showCaddieAssignments) return false;
    if(bookingPlayer)
        if(bookingPlayer.caddyPreferred && bookingPlayer.caddyAssigned 
            && bookingPlayer.caddyPreferred.id === bookingPlayer.caddyAssigned.id) return true;
        else return false;
    let _clubs = [];
    let _showCaddyAssigned: boolean = true;
    if(this.caddyAssignmentInfo) 
        _showCaddyAssigned = this.caddyAssignmentInfo.show;
    if(this.caddyAssignmentInfo && this.caddyAssignmentInfo.excludedClubs)  {
        _clubs = this.caddyAssignmentInfo.excludedClubs.filter((clubId)=>{
            return clubId === this.teeSlot.clubData.id
        })
    }
    return _showCaddyAssigned && !(_clubs && _clubs.length > 0);
    
    
}
showCaddyAssignmentText(bookingPlayer: TeeTimeBookingPlayer, short: boolean = false) {
    console.debug("show caddy assignment text : ", this.appAttribute)
    if(!bookingPlayer) return '';
    // if(!this.appAttribute) return '';
    if(this.caddyAssignmentInfo) {
        if(bookingPlayer.caddyPreferred && bookingPlayer.caddyAssigned 
            && bookingPlayer.caddyPreferred.id !== bookingPlayer.caddyAssigned.id) {
                if(short) return this.caddyAssignmentInfo.shortDiffCaddyAssignedText;
                else return this.caddyAssignmentInfo.diffCaddyAssignedText;
        } else  if(bookingPlayer.caddyPreferred && bookingPlayer.caddyAssigned 
            && bookingPlayer.caddyPreferred.id === bookingPlayer.caddyAssigned.id) {
                if(short) return this.caddyAssignmentInfo.shortDisplayText;
                else return this.caddyAssignmentInfo.displayText;
            } else if(bookingPlayer.caddyAssigned && !bookingPlayer.caddyPreferred) {  
                if(short) return this.caddyAssignmentInfo.shortDisplayText;
                else return this.caddyAssignmentInfo.displayText;
        }
    }
    else if(!this.caddyAssignmentInfo) {
        if(bookingPlayer.caddyPreferred && bookingPlayer.caddyAssigned 
            && bookingPlayer.caddyPreferred.id === bookingPlayer.caddyAssigned.id) {
                if(short) return 'Assigned';
                else return 'Caddy Assigned'
        } else  if(bookingPlayer.caddyPreferred && bookingPlayer.caddyAssigned 
            && bookingPlayer.caddyPreferred.id !== bookingPlayer.caddyAssigned.id) {
            if(short) return 'Different caddie';
            else return 'Different caddy has been assigned'
        } else {
            if(short) return 'Assigned';
                else return 'Caddy Assigned'
        }
    } 
        
}
}
